import type { MapaCargo } from '@/components/Configuracao/mapaCargos/mapaCargosTypes'

export const CARGO_ANALISE_DE_UX_EXPERIENCIA_DO_USUARIO: MapaCargo = 
{
  id: 'analise-de-ux-experiencia-do-usuario',
  titulo: 'Análise de UX (Experiência do Usuário)',
  setor: 'Criação',
  secoes: [
    {
      id: 'responsabilidades',
      titulo: 'Responsabilidades',
      atividades: [
        'Melhorar elementos de navegação e design para reduzir taxas de rejeição e aumentar o tempo de permanência no site.',
        'Trabalhar em colaboração com designers para criar interfaces amigáveis e otimizadas para SEO.',
      ],
    },
    {
      id: 'integracao-com-outras-areas-de-marketing-digital',
      titulo: 'Integração com outras áreas de marketing digital',
      atividades: [
        'Trabalhar com equipes de PPC para alinhar estratégias de palavras-chave.',
        'Coordenar esforços com equipes de conteúdo e mídias sociais para potencializar resultados.',
      ],
    },
    {
      id: 'analise-de-concorrencia-em-seo-avancado',
      titulo: 'Análise de concorrência em SEO avançado',
      atividades: [
        'Identificar estratégias de sucesso dos concorrentes e buscar oportunidades para superá-los em rankings.',
        'Monitorar o crescimento e perda de tráfego de concorrentes.',
      ],
    },
    {
      id: 'planejamento-de-migracao-de-sites',
      titulo: 'Planejamento de migração de sites',
      atividades: [
        'Garantir que uma migração ou redesign de site não prejudique o SEO existente.',
        'Implementar redirecionamentos 301 e monitorar rankings durante o processo.',
      ],
    },
    {
      id: 'treinamento-e-capacitacao-de-equipes',
      titulo: 'Treinamento e capacitação de equipes',
      atividades: [
        'Ensinar boas práticas de SEO para redatores, desenvolvedores e outros membros da equipe.',
        'Promover a cultura de SEO na empresa.',
      ],
    },
    {
      id: 'analise-preditiva-de-seo',
      titulo: 'Análise preditiva de SEO',
      atividades: [
        'Usar ferramentas e dados históricos para prever o impacto de novas estratégias de SEO.',
        'Definir metas realistas com base em tendências de mercado e desempenho anterior.',
      ],
    },
    {
      id: 'atendimento-ao-cliente',
      titulo: 'Atendimento ao cliente',
      atividades: [
        'Servir de ponto de contato entre clientes e a equipe da agência.',
        'Reunir feedbacks e acompanhar aprovações e revisões.',
      ],
    },
  ],
}
